/*
 * AUTO OBRAZY — doplnkový predaj nálepiek v košíku.
 *
 * V254: predtým sa po pridaní znovu načítala celá stránka. Na telefóne to
 * trvalo sekundy a v bočnom paneli košíka to nefungovalo vôbec. Teraz sa
 * použije rovnaká cesta, akou si téma pridáva darček a ochranu zásielky:
 * /cart/add.js so zoznamom sekcií a udalosť cart:update — takže sa
 * prekreslí iba košík a stav dopravy ani pokladne sa nestratí.
 */
(function () {
  'use strict';
  if (window.__aoXsell) return;
  window.__aoXsell = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    if (window.AOMoney && window.AOMoney.format) return window.AOMoney.format(cents);
    return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* Zoznam sekcií košíka, ktoré má Shopify prekresliť. Bez neho by sa
     obsah košíka po pridaní neobnovil a zákazník by nálepku nevidel. */
  function sectionData() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    if (!ids.length) return {};
    return { sections: ids.join(','), sections_url: window.location.pathname };
  }

  function chosenQty(card) {
    var on = card && card.querySelector('[data-ao-xsell-pack].is-on');
    var q = on ? Number(on.getAttribute('data-qty')) : 1;
    return q > 0 ? q : 1;
  }

  /* ---------- výber počtu kusov ---------- */
  document.addEventListener('click', function (event) {
    var pack = event.target.closest ? event.target.closest('[data-ao-xsell-pack]') : null;
    if (!pack) return;
    event.preventDefault();
    var card = pack.closest('[data-ao-xsell-card]');
    if (!card) return;
    card.querySelectorAll('[data-ao-xsell-pack]').forEach(function (b) {
      var on = b === pack;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var unit = Number(card.getAttribute('data-unit')) || 0;
    var priceEl = card.querySelector('[data-ao-xsell-price]');
    if (priceEl) priceEl.textContent = money(unit * chosenQty(card));
  });

  /* ---------- zväčšenie nálepky ---------- */
  var lightbox = null;
  function openZoom(src, title) {
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'ao-xsell-zoom';
      lightbox.innerHTML = '<button type="button" class="ao-xsell-zoom__close" aria-label="Zavrieť">'
        + '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m5 5 10 10M15 5 5 15"/></svg></button>'
        + '<img alt=""><p class="ao-xsell-zoom__title"></p>';
      document.body.appendChild(lightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.closest('.ao-xsell-zoom__close')) closeZoom();
      });
    }
    lightbox.querySelector('img').src = src;
    lightbox.querySelector('img').alt = title || '';
    lightbox.querySelector('.ao-xsell-zoom__title').textContent = title || '';
    lightbox.classList.add('is-open');
  }
  function closeZoom() { if (lightbox) lightbox.classList.remove('is-open'); }

  document.addEventListener('click', function (event) {
    var zoom = event.target.closest ? event.target.closest('[data-ao-xsell-zoom]') : null;
    if (!zoom) return;
    event.preventDefault();
    openZoom(zoom.getAttribute('data-full'), zoom.getAttribute('data-title'));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });

  /* ---------- pridanie do košíka ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-ao-xsell-add]') : null;
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var card = btn.closest('[data-ao-xsell-card]');
    var wrap = btn.closest('[data-ao-xsell]');
    var errEl = wrap ? wrap.querySelector('[data-ao-xsell-error]') : null;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Pridávam…';

    fetch(root.replace(/\/$/, '') + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(Object.assign(
        { items: [{ id: Number(id), quantity: chosenQty(card) }] },
        sectionData()
      ))
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed-' + res.status);
        return res.json();
      })
      .then(function (added) {
        try {
          if (window.AOAnalytics && window.AOAnalytics.track) {
            window.AOAnalytics.track('xsell_add_success', { variant_id: id, quantity: chosenQty(card) });
          }
        } catch (e) {}
        /* Košík si vypýtame znova aj so sekciami, nech sa prekreslí panel
           aj stránka naraz a nikde neostane stará suma. */
        return fetch(root.replace(/\/$/, '') + '/cart.js', {
          headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store'
        }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart || added,
              data: {
                source: 'ao-cart-stickers',
                itemCount: cart ? Number(cart.item_count) || 0 : 0,
                sections: (added && added.sections) || undefined
              }
            }
          }));
          btn.textContent = 'Pridané ✓';
          window.setTimeout(function () {
            btn.disabled = false;
            btn.textContent = original;
          }, 1400);
        });
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        if (errEl) {
          errEl.textContent = 'Nálepku sa nepodarilo pridať. Skús to prosím znova, alebo ju pridaj z jej vlastnej stránky.';
          errEl.hidden = false;
        }
      });
  }, false);

})();
